import React from 'react'
import { FormattedMessage, useIntl } from 'react-intl'

import { tID } from '../../utils/utils'
import { TextModal } from '../textModal/TextModal'

export type OnboardingExitModalProps = {
  isVisible: boolean
  onCancel: () => void
  onExit: () => void
  isLatestMatches?: boolean
}

export const OnboardingExitModal = ({ isVisible, onCancel, onExit, isLatestMatches }: OnboardingExitModalProps) => {
  const { formatMessage } = useIntl()

  const title = !isLatestMatches
    ? formatMessage({
        defaultMessage: 'Exit without finishing?',
        description: 'Prompt asking if the user wants to leave onboarding even though they have not yet completed it',
      })
    : formatMessage({
        defaultMessage: 'Exit without booking?',
        description: 'Prompt asking if the user wants to leave booking if they are in latest provider matches flow',
      })

  const description = !isLatestMatches
    ? formatMessage({
        defaultMessage:
          'To ensure your responses are current, they are only saved for a short period of time. You may need to start over when you return.',
        description:
          'Message that appears before the user exits onboarding to warn that the information they entered may be gone the next time they return',
      })
    : formatMessage({
        defaultMessage: 'Since appointment availability may change, you will need to start over when you return.',
        description:
          'Message that appears before the user exits booking for latest provider results to warn that the availability for providers might not be the same',
      })

  return (
    <TextModal
      isOpen={isVisible}
      onClose={onCancel}
      title={title}
      description={description}
      textAlignment='left'
      secondaryCTA={onCancel}
      secondaryButtonText={
        <FormattedMessage
          defaultMessage='Cancel'
          description='Label of button that closes the modal if the user decides not to exit onboarding'
        />
      }
      secondaryButtonTestID={tID('OnboardingExitModal-cancelButton')}
      primaryCTA={onExit}
      primaryButtonText={
        <FormattedMessage
          defaultMessage='Exit'
          description='Label of button that allows the user to leave the onboarding flow and return to the home base'
        />
      }
      primaryButtonTestID={tID('OnboardingExitModal-exitButton')}
      testID={tID('OnboardingExitModal')}
    />
  )
}
